import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IDownloadObraDocumentoUseCase } from "../../../presentation/useCases/read/download_obra_documento_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DownloadObraDocumentoUseCase
 */

export class DownloadObraDocumentoUseCase implements IDownloadObraDocumentoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async downloadObraDocumento(
    idObraArquivo: number,
    arquivoNome: string,
  ): Promise<void> {
    const result = await this.repository.downloadObraDocumento(idObraArquivo);
    await downloadFromBlobUrl(result, arquivoNome);
  }
}
